import { render } from "./ShieldIcon.vue?vue&type=template&id=fbb9c8ce"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__